import { SizeGuideSection } from "../size-guide-section"

// src/components/size-guide-new/men/shirts.tsx
const shirtsTableData = {
  headers: [
    [
      {
        content: "Men's Shirts",
        colSpan: 3
      }
    ],
    [
      {
        content: "Size"
      },
      {
        content: "Chest(In)"
      },
      {
        content: "Waist(In)"
      }
    ]
  ],
  data: [
    [
      { content: "S" },
      { content: "34-36" },
      { content: "28-30" }
    ],
    [
      { content: "M" },
      { content: "38-40" },
      { content: "32-34" }
    ],
    [
      { content: "L" },
      { content: "42-44" },
      { content: "36-38" }
    ],
    [
      { content: "XL" },
      { content: "46-48" },
      { content: "40-42" }
    ],
    [
      { content: "XXL" },
      { content: "50-52" },
      { content: "44-46" }
    ],
    [
      { content: "3XL" },
      { content: "54-56" },
      { content: "48-50" }
    ]
  ]
}

export const Shirts = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title="Shirts"
    tableData={shirtsTableData}
    className={className}
  />
}